module.exports = __webpack_public_path__ + "static/media/xiaomi_265.523ccfae.png";